ui-cms-table {
  display: block;
  overflow-x: auto;

  .sd-table {
    width: 100%;
  }

  caption {
    display: none;
  }

  th {
    font-weight: $sd-fontWeight-normal;
  }

  .firstColumnAsHeader {
    tr th:first-of-type {
      font-weight: $sd-fontWeight-bold;
      position: sticky;
      left: 0;
      z-index: 1;
    }
  }

  .firstRowAsHeader {
    thead tr:first-of-type {
      th {
        font-weight: $sd-fontWeight-bold;
      }
    }
  }

  // color tables should still use the same colors as before
  .colorTableGray {
    --background-color-1: #{$ui-grey-minus-3};
    --background-color-2: #{$ui-grey-minus-2};
    --background-color-3: #{$ui-grey-minus-1};
    --background-color-4: #{$ui-grey};
    --background-color-5: #{$ui-grey-plus-1};
    --background-color-6: #{$ui-grey-plus-2};
    --background-color-7: #{$ui-grey-plus-3};
    --background-color-8: #{$ui-grey-plus-4};
    --text-color-7: #{$ui-white};
    --text-color-8: #{$ui-white};
  }

  .colorTableTurquoise {
    --background-color-1: #{$ui-turquoise-minus-4};
    --background-color-2: #{$ui-turquoise-minus-3};
    --background-color-3: #{$ui-turquoise-minus-2};
    --background-color-4: #{$ui-turquoise-minus-1};
    --background-color-5: #{$ui-turquoise};
    --background-color-6: #{$ui-turquoise-plus-1};
    --background-color-7: #{$ui-turquoise-plus-2};
    --background-color-8: #{$ui-turquoise-plus-3};
    --text-color-6: #{$ui-white};
    --text-color-7: #{$ui-white};
    --text-color-8: #{$ui-white};
  }

  .colorTableYellow {
    --background-color-1: #{$ui-yellow-minus-2};
    --background-color-2: #{$ui-yellow-minus-1};
    --background-color-3: #{$ui-yellow};
    --background-color-4: #{$ui-yellow-plus-1};
    --background-color-5: #{$ui-yellow-plus-2};
    --background-color-6: #{$ui-yellow-plus-3};
    --background-color-7: #{$ui-yellow-plus-4};
    --background-color-8: #{$ui-yellow-plus-5};
    --background-color-9: #{$ui-yellow-plus-6};
    --text-color-9: #{$ui-white};
  }

  .colorTableLightBlue {
    --background-color-1: #{$ui-lightblue-minus-4};
    --background-color-2: #{$ui-lightblue-minus-3};
    --background-color-3: #{$ui-lightblue-minus-2};
    --background-color-4: #{$ui-lightblue-minus-1};
    --background-color-5: #{$ui-lightblue};
    --background-color-6: #{$ui-lightblue-plus-1};
    --background-color-7: #{$ui-lightblue-plus-2};
    --background-color-8: #{$ui-lightblue-plus-3};
    --text-color-6: #{$ui-white};
    --text-color-7: #{$ui-white};
    --text-color-8: #{$ui-white};
  }

  .colorTableViolet {
    --background-color-1: #{$ui-purple-minus-5};
    --background-color-2: #{$ui-purple-minus-4};
    --background-color-3: #{$ui-purple-minus-3};
    --background-color-4: #{$ui-purple-minus-2};
    --background-color-5: #{$ui-purple-minus-1};
    --background-color-6: #{$ui-purple};
    --background-color-7: #{$ui-purple-plus-1};
    --background-color-8: #{$ui-purple-plus-2};
    --text-color-6: #{$ui-white};
    --text-color-7: #{$ui-white};
    --text-color-8: #{$ui-white};
  }

  .colorTableYellowGreen {
    --background-color-1: #{$ui-yellowgreen-minus-2};
    --background-color-2: #{$ui-yellowgreen-minus-1};
    --background-color-3: #{$ui-yellowgreen};
    --background-color-4: #{$ui-yellowgreen-plus-1};
    --background-color-5: #{$ui-yellowgreen-plus-2};
    --background-color-6: #{$ui-yellowgreen-plus-3};
    --background-color-7: #{$ui-yellowgreen-plus-4};
    --background-color-8: #{$ui-yellowgreen-plus-5};
    --text-color-7: #{$ui-white};
    --text-color-8: #{$ui-white};
  }

  .colorTableHighlight {
    --background-color-1: #{$ui-yellow};
    --background-color-2: #{$ui-red};
    --text-color-2: #{$ui-white};
  }

  .colorTableTrafficLight {
    --background-color-1: #{$ui-green};
    --background-color-2: #{$ui-yellow};
    --background-color-3: #{$ui-red};
    --text-color-1: #{$ui-white};
    --text-color-3: #{$ui-white};
  }

  .colorTableTextAndHighlight {
    --background-color-1: #{$ui-dark};
    --background-color-2: #{$ui-red-plus-1};
    --background-color-3: #{$ui-red-plus-2};
    --background-color-4: #{$ui-red-plus-3};
    --text-color-1: #{$ui-white};
    --text-color-2: #{$ui-white};
    --text-color-3: #{$ui-white};
    --text-color-4: #{$ui-white};
  }

  .colorTableRisk {
    --background-color-1: #{$ui-risk-class-1};
    --background-color-2: #{$ui-risk-class-2};
    --background-color-3: #{$ui-risk-class-3};
    --background-color-4: #{$ui-risk-class-4};
    --background-color-5: #{$ui-risk-class-5};
    --text-color-1: #{$ui-white};
    --text-color-2: #{$ui-white};
    --text-color-5: #{$ui-white};
  }

  .colorTableColorClimate {
    --background-color-1: #0066b3;
    --background-color-2: #f60;
  }

  .colorTablePrimaryBlue {
    --background-color-1: #{$ui-blue-minus-5};
    --background-color-2: #{$ui-blue-minus-4};
    --background-color-3: #{$ui-blue-minus-3};
    --background-color-4: #{$ui-blue-minus-2};
    --background-color-5: #{$ui-blue-minus-1};
    --background-color-6: #{$ui-blue};
    --background-color-7: #{$ui-blue-plus-1};
    --background-color-8: #{$ui-blue-plus-2};
    --text-color-5: #{$ui-white};
    --text-color-6: #{$ui-white};
    --text-color-7: #{$ui-white};
    --text-color-8: #{$ui-white};
  }

  .colorTablePrimaryGreen {
    --background-color-1: #{$ui-green-minus-3};
    --background-color-2: #{$ui-green-minus-2};
    --background-color-3: #{$ui-green-minus-1};
    --background-color-4: #{$ui-green};
    --background-color-5: #{$ui-green-plus-1};
    --background-color-6: #{$ui-green-plus-1-5};
    --background-color-7: #{$ui-green-plus-2};
    --background-color-8: #{$ui-green-plus-3};
    --background-color-9: #{$ui-green-plus-4};
    --text-color-5: #{$ui-white};
    --text-color-6: #{$ui-white};
    --text-color-7: #{$ui-white};
    --text-color-8: #{$ui-white};
    --text-color-9: #{$ui-white};
  }

  .colorTableIllustrations {
    --background-color-1: #f5d9c2;
    --background-color-2: #d9b89e;
    --background-color-3: #bfa18a;
    --background-color-4: #947561;
    --background-color-5: #594738;
    --background-color-6: #ffc8c8;
    --background-color-7: #f08e94;
    --background-color-8: #e42444;
    --background-color-9: #ac1938;
    --background-color-10: #7d142d;
    --background-color-11: #ffcb6b;
    --background-color-12: #ffa605;
    --background-color-13: #f78901;
    --text-color-4: #{$ui-white};
    --text-color-5: #{$ui-white};
    --text-color-8: #{$ui-white};
    --text-color-9: #{$ui-white};
    --text-color-10: #{$ui-white};
  }

  .color-table {
    td {
      min-width: 16%;

      p {
        margin: 0;
      }
    }

    tr {
      th:first-of-type {
        min-width: 120px;
      }
    }

    tr:nth-of-type(2) th:nth-of-type(1) {
      background-color: var(--background-color-1);
      color: var(--text-color-1, #000); // if text color is not passed, default/fallback is black
    }

    tr:nth-of-type(3) th:nth-of-type(1) {
      background-color: var(--background-color-2);
      color: var(--text-color-2, #000);
    }

    tr:nth-of-type(4) th:nth-of-type(1) {
      background-color: var(--background-color-3);
      color: var(--text-color-3, #000);
    }

    tr:nth-of-type(5) th:nth-of-type(1) {
      background-color: var(--background-color-4);
      color: var(--text-color-4, #000);
    }

    tr:nth-of-type(6) th:nth-of-type(1) {
      background-color: var(--background-color-5);
      color: var(--text-color-5, #000);
    }

    tr:nth-of-type(7) th:nth-of-type(1) {
      background-color: var(--background-color-6);
      color: var(--text-color-6, #000);
    }

    tr:nth-of-type(8) th:nth-of-type(1) {
      background-color: var(--background-color-7);
      color: var(--text-color-7, #000);
    }

    tr:nth-of-type(9) th:nth-of-type(1) {
      background-color: var(--background-color-8);
      color: var(--text-color-8, #000);
    }

    tr:nth-of-type(10) th:nth-of-type(1) {
      background-color: var(--background-color-9);
      color: var(--text-color-9, #000);
    }

    tr:nth-of-type(11) th:nth-of-type(1) {
      background-color: var(--background-color-10);
      color: var(--text-color-10, #000);
    }

    tr:nth-of-type(12) th:nth-of-type(1) {
      background-color: var(--background-color-11);
      color: var(--text-color-11, #000);
    }

    tr:nth-of-type(13) th:nth-of-type(1) {
      background-color: var(--background-color-12);
      color: var(--text-color-12, #000);
    }

    tr:nth-of-type(14) th:nth-of-type(1) {
      background-color: var(--background-color-13);
      color: var(--text-color-13, #000);
    }
  }
}
